/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum EventLogMessageResponseEventLogContextTypeEnum {
  Compact = 'Compact',
  Buyer = 'Buyer',
  Project = 'Project',
}
